import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { getFavorites } from '../../utils/api';
import { DbProduct } from '../../utils/api';
import ProductCard from './ProductCard';
import { useFavorites } from '../auth/FavoritesContext';
import Seo from '../common/Seo';

const MyFavorites = () => {
  const [products, setProducts] = useState<DbProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const { favoriteIds } = useFavorites();

  useEffect(() => {
    getFavorites().then(res => {
      if (res.success && res.data) {
        setProducts(res.data);
      }
      setLoading(false);
    });
  }, []);

  // Wenn sich Favoriten ändern (Toggle), direkt aus der Liste entfernen
  useEffect(() => {
    setProducts(prev => prev.filter(p => favoriteIds.has(p.id)));
  }, [favoriteIds]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Seo title="Meine Favoriten | SportyReplay" noindex />
      <div className="flex items-center gap-3 mb-8">
        <Heart className="w-7 h-7 text-red-500 fill-red-500" />
        <h1 className="text-2xl font-bold text-gray-800">Meine Merkliste</h1>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-16">
          <Heart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-600 mb-2">Noch keine Favoriten</h2>
          <p className="text-gray-500 mb-6">Speichere Artikel, die dir gefallen, mit dem Herz-Button.</p>
          <Link
            to="/products"
            className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all"
          >
            Produkte entdecken
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map(product => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyFavorites;
